import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    GridMobileContainer,
    ItemDetailText,
    OnHandText,
    LoTtext,
    MdiOptions,
    UsedBytext,
    ItemCardTextMobileContainer,
    NTIconContainer,
    NTIcon,
    TIcon,
    TIconContainer,
    MaxExpirytext,
} from './InventoryBody.styled';
import TextWithInputs from '../common/textWithInputs/TextWithInputs';
import RedAlertIcon from 'src/assets/images/RedAlertIcon.svg';
import AlertMsg from '../../components/common/AlertMsg';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import ClockAlertOutline from 'src/assets/images/ClockAlertOutline.svg';
import { setInventoryItems } from '../../redux/actions';
import { isMobileDevice } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
export default function InventoryBodyMobile({
    user,
    handleChange,
    index,
    setQtyVal,
    setQuantityValue,
    setItemDetails,
    clrAll,
}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState('');
    const [checked, setChecked] = useState(false);
    const [quantityValidation, setQuantityValidation] = useState(false);
    const handleQtyValidation = (e, uniqueKey) => {
        setQuantityValue(e.target.value);
        setItemDetails(index, e.target.value, uniqueKey);
    };
    const checkedItemsBody = useSelector(
        (state) => state.inventoryReducer.checkedItems
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    useEffectWithErrorLogging(() => {
        if (Object.prototype.hasOwnProperty.call(user, 'isChecked')) {
            const items = checkedItemsBody
                .filter((item) => item != undefined)
                .map((itemData) => ({
                    ...itemData,
                    flag: itemData.onHand < itemData.used ? true : false,
                }));
            if (user.isChecked) {
                checkedItemsBody &&
                    checkedItemsBody.map((item) => {
                        if (item.uniqueKey === user.uniqueKey) {
                            setQuantity(item.used);
                            errorValidation(item.used, item.onHand);
                            if (item.onHand < item.used) {
                                setQuantityValidation(true);
                            } else {
                                setQuantityValidation(false);
                            }
                        }
                    });
                setChecked(true);
            } else {
                setQuantity('');
                setChecked(false);
                setQuantityValidation(false);
            }
        }
    }, [user?.isChecked]);

    const loading = useSelector((state) => state.inventoryReducer.loading);
    const errorValidation = (value, onHand) => {
        if (value && value > onHand) {
            user.flag = true;
        } else {
            user.flag = false;
        }
    };
    return (
        <div>
            {loading == false ? (
                <GridMobileContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <ItemCardTextMobileContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                        key={index}
                    >
                        <div style={{ marginTop: '-4px' }}>
                            <Checkbox
                                name={user.lotSerial}
                                key={index}
                                value={user.uniqueKey}
                                checked={
                                    checked ? checked : user?.isChecked || false
                                }
                                onCheckboxSelectionChange={(e) =>
                                    handleChange(e, clrAll)
                                }
                                id="consignmentBilling-inventory-InventoryBodyMobile-lotSerial-checkbox"
                                margin={'6px 0 0 0'}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'true'}
                                disableFocusEffect={'true'}
                            />
                        </div>
                    </ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={7}
                        sm={7}
                        md={7}
                        lg={7}
                        xl={7}
                        mobile={7}
                    >
                        <div
                            style={{
                                paddingLeft: '15px',
                                paddingRight: '10px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <ItemDetailText isDemi>
                                    {user.cfn}
                                </ItemDetailText>
                                {countryISOCode === 'US' ? (
                                    <div>
                                        {user.salesOrg === 'S030' ? (
                                            <TIconContainer marginRight={'6px'}>
                                                <TIcon>
                                                    {t(
                                                        'consignmentBilling.inventory.t'
                                                    )}
                                                </TIcon>
                                            </TIconContainer>
                                        ) : (
                                            <NTIconContainer
                                                marginRight={'6px'}
                                            >
                                                <NTIcon>
                                                    {t(
                                                        'consignmentBilling.inventory.nt'
                                                    )}
                                                </NTIcon>
                                            </NTIconContainer>
                                        )}
                                    </div>
                                ) : null}
                            </div>
                            <ItemDetailText isRegular>
                                {user.materialDesc}
                            </ItemDetailText>
                        </div>
                    </ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        justifyContent={'center'}
                        item
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                        xl={4}
                        mobile={4}
                    >
                        <div style={{ marginTop: '5px' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    justifyContent: 'space-around',
                                }}
                            >
                                <TextWithInputs
                                    name={t('common.qty')}
                                    placeholder={'0'}
                                    maxLength={2}
                                    inputHeight={'40px'}
                                    inputWidth={'58px'}
                                    inputBorder={
                                        quantityValidation
                                            ? '2px solid #FACFD6'
                                            : ''
                                    }
                                    alignText={'center'}
                                    fSize={'15px'}
                                    onkeyUp={(e) => {
                                        setQuantity(
                                            e.target.value
                                                ? e.target.value.replace(
                                                      /[^0-9]+/g,
                                                      ''
                                                  )
                                                : ''
                                        );
                                        setQtyVal(e.target.value);
                                        e.target.value &&
                                        e.target.value.length > 0 &&
                                        e.target.value > user.onHand
                                            ? setQuantityValidation(true)
                                            : setQuantityValidation(false);
                                        handleQtyValidation(e, user.uniqueKey);
                                        errorValidation(
                                            e.target.value,
                                            user.onHand
                                        );
                                    }}
                                    //errorMsg = {qtyErrorMsg}
                                    value={quantity}
                                />
                                <OnHandText>&nbsp; / {user.onHand}</OnHandText>
                            </div>
                        </div>
                    </ItemCardTextMobileContainer>

                    {quantityValidation && isMobileDevice() && (
                        <div
                            style={{
                                display: 'block',
                                paddingLeft: '12.3333%',
                                width: '100%',
                                paddingTop: '5px',
                            }}
                        >
                            <span
                                style={{
                                    display: 'flex',
                                }}
                            >
                                <AlertMsg
                                    message={t(
                                        'consignmentBilling.inventory.quantityExceeds'
                                    )}
                                />
                            </span>
                        </div>
                    )}

                    <ItemCardTextMobileContainer
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        mobile={1}
                        key={index}
                    ></ItemCardTextMobileContainer>
                    <ItemCardTextMobileContainer
                        item
                        xs={5}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        mobile={5}
                    >
                        <div>
                            {quantityValidation ? (
                                <LoTtext
                                fontSize={isLanguageChanged &&'12px'}
                                    marginLeft={'3.4rem'}
                                    isDemi
                                    style={{
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {t(
                                        'consignmentBilling.inventory.lotorserial'
                                    )}{' '}
                                    <LoTtext isRegular letterSpacing={'-1.1px'}
                                    fontSize={isLanguageChanged &&'12px'}>
                                        {user.lotSerial}
                                    </LoTtext>
                                </LoTtext>
                            ) : (
                                <LoTtext
                                fontSize={isLanguageChanged &&'12px'}
                                    isDemi
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    {t(
                                        'consignmentBilling.inventory.lotorserial'
                                    )}{' '}
                                    <LoTtext
                                    fontSize={isLanguageChanged &&'12px'}
                                    isRegular letterSpacing={'-1.1px'}>
                                        {user.lotSerial}
                                    </LoTtext>
                                </LoTtext>
                            )}
                        </div>
                    </ItemCardTextMobileContainer>

                    <ItemCardTextMobileContainer
                        item
                        xs={5}
                        sm={5}
                        md={5}
                        lg={5}
                        xl={5}
                        mobile={5}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                margin:
                                    user.expiryStatus === ''
                                        ? '4px auto 0 auto'
                                        : '4px auto auto 0',
                            }}
                        >
                            {user.expiryStatus === 'EXPIRED' ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginLeft: '0.5px',
                                    }}
                                >
                                    <MdiOptions
                                        mbMarginLeft={'-10px'}
                                        imageSrc={RedAlertIcon}
                                    />
                                    <UsedBytext isDemi>
                                        {t(
                                            'consignmentBilling.inventory.expired'
                                        )}
                                    </UsedBytext>
                                    <UsedBytext isRegular>
                                        &nbsp;{user.useByDate}
                                    </UsedBytext>
                                </div>
                            ) : user.expiryStatus === 'minexpiry' ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <MdiOptions imageSrc={ClockAlertOutline} />
                                    <MaxExpirytext isDemi
                                    fontSize={isLanguageChanged &&'12px'}>
                                        {t(
                                            'consignmentBilling.inventory.useBy'
                                        )}
                                    </MaxExpirytext>
                                    <MaxExpirytext isRegular
                                    fontSize={isLanguageChanged &&'12px'}>
                                        &nbsp;{user.useByDate}
                                    </MaxExpirytext>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {/* <MdiOptions
                            mbMarginLeft={'-10px'}
                            imageSrc={ClockAlertOutline}
                        /> */}
                                    <LoTtext isDemi
                                    fontSize={isLanguageChanged &&'12px'}>
                                        {t(
                                            'consignmentBilling.inventory.useBy'
                                        )}
                                    </LoTtext>
                                    <LoTtext isRegular
                                    fontSize={isLanguageChanged &&'12px'}>
                                        &nbsp;{user.useByDate}
                                    </LoTtext>
                                </div>
                            )}
                        </div>
                    </ItemCardTextMobileContainer>
                </GridMobileContainer>
            ) : null}
        </div>
    );
}
